import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    CreateActivityTracker,
    GetDeliveryById,
    GetEquipmentDetailsById,
    GetTrackByDeliveryId,
    UploadActivityTracker,
} from '../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { toast } from 'react-toastify';
import { ACTIVITY_TRACKER_ITEM_MODEL } from '../EquipmentAndMaterial/Model/Model';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeliveryEntranceTabApp = (props) => {
    const { t, setShowMarkAsReadModal, onHide, materialId, markAsCompleted } = props;
    const [commentData, setCommentData] = useState({ text: '', file: null });
    const [modified, setModified] = useState(false);
    const [delivery, setDelivery] = useState(null);
    const [equipmentDeliveryId, setEquipmentDeliveryId] = useState('')
    const [activityTracker, setActivityTracker] = useState(null);
    const dispatch = useDispatch();
    const option = '';
    const authState = useSelector((state) => state.authenticatioauthennSlice);
    const userId = authState?.user?.data?.id;
    const handleMarkAsCompleted = () => {
        onHide();
        setShowMarkAsReadModal(true);
    };

    useEffect(() => {
        if (!materialId) return;

        dispatch(GetEquipmentDetailsById(materialId)).then(
            ({
                payload: {
                    data: { success, data },
                },
            }) => {
                if (!success) return;
                 setEquipmentDeliveryId(data.equipmentDeliveryId)
                // If the equipment has an associated delivery,
                // fetch the delivery details
                if (data?.equipmentDeliveryId) {
                    dispatch(GetDeliveryById(data.equipmentDeliveryId)).then(
                        ({
                            payload: {
                                data: { success, data },
                            },
                        }) => {
                            if (success) {
                                setDelivery(data);
                            }
                        },
                    );
                    dispatch(GetTrackByDeliveryId(data.equipmentDeliveryId)).then(
                        ({
                            payload: {
                                data: { success, data },
                            },
                        }) => {
                            if (success) {
                                setActivityTracker(data);
                            }
                        },
                    );
                }
            },
        );
    }, [materialId, dispatch, modified, markAsCompleted]);

    const handleSendMessage = ({ text, file }) => {
        if (!text || text.trim() === '') return;
        createActivityTracker(text, file);
    };
    /**
     * Creates a new activity tracker record and uploads a file if provided
     */

    const createActivityTracker = (text, file) => {
        const payload = ACTIVITY_TRACKER_ITEM_MODEL.toRegister({
            equipmentDeliveryId: equipmentDeliveryId,
            userId,
            message: text,
        });

        dispatch(CreateActivityTracker(payload))
            .then(({ payload: createRes }) => {
                const successCreate = createRes?.data?.success;
                const trackerData = createRes?.data?.data;

                if (!successCreate || !trackerData?.id) return Promise.reject();
                if (file) {
                    return uploadActivityTracker(trackerData.id, file);
                }
                return Promise.resolve();
            })
            .then(() => {
                toast.success(t('has_been_created_successfully'));
                setModified(true);
            });
    };
    const uploadActivityTracker = (trackerId, file) => {
        const formData = new FormData();
        formData.append('id', trackerId);
        formData.append('fileUploadDto.userFileNames', file.name);
        formData.append('fileUploadDto.files', file);
        return dispatch(UploadActivityTracker(formData));
    };
    return {
        dispatch,
        option,
        t,
        handleMarkAsCompleted,
        setCommentData,
        delivery,
        activityTracker,
        handleSendMessage,
        modified,
        setModified
    };
};

export default DeliveryEntranceTabApp;
